/**
 * Shared types and utilities for RubricaEditor components
 */

export type TGuiaNotas = Record<string, string>;

export type TGuiaNotasEntry = {
  nota: number;
  descricao: string;
};

const DEFAULT_ESCALA_MAX = 5;
export const DEFAULT_ESCALA_MIN = 1;
export const DEFAULT_PESO = 1;
export const DEFAULT_DESCRIPTION_ROWS = 3;
export const DEFAULT_CRITERIO_ROWS = 4;

export const DEFAULT_CRITERIO: TCriterioRubrica = {
  id: "",
  nome: "",
  descricao: "",
  peso: DEFAULT_PESO,
  escalaMin: DEFAULT_ESCALA_MIN,
  escalaMax: DEFAULT_ESCALA_MAX,
  guiaNotas: {},
  obrigatorio: true
};

/**
 * Converts a Record<string, string> guiaNotas to sorted array entries
 * @param guiaNotas
 */
export function normalizeGuiaNotas(guiaNotas: TGuiaNotas): TGuiaNotasEntry[] {
  return Object.entries(guiaNotas)
    .map(([nota, descricao]) => ({
      nota: Number(nota),
      descricao
    }))
    .filter((entry) => Number.isFinite(entry.nota))
    .sort((a, b) => a.nota - b.nota);
}

/**
 * Converts array entries back to Record<string, string> format
 * @param entries
 */
export function buildGuiaNotasRecord(entries: TGuiaNotasEntry[]): TGuiaNotas {
  return Object.fromEntries(entries.map((entry) => [String(entry.nota), entry.descricao])) as TGuiaNotas;
}
